import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_44: DocMigration = {
  maxSchemaVersion: "0.0.44",
  apply(json: any) {
    if (json.tables?.settings) {
      for (const tableId in json.tables.settings) {
        const table = json.tables.settings[tableId];
        if (table.type === "FOUNDATION_SETTINGS") {
          if (table.foundationSubSystemType === undefined) {
            table.foundationSubSystemType === "MONOLITHIC";
          }
          if (table.brickLedge !== undefined) {
            if (table.brickLedge) {
              table.brickLedgeType = "AT_FOOTING";
            } else {
              table.brickLedgeType = "NONE";
            }
            delete table["brickLedge"];
          } else {
            table.brickLedgeType = "AT_FOOTING";
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_44;
